import { Controller } from "@hotwired/stimulus"
import { HSStaticMethods, HSOverlay } from "preline/preline"

// Controller to initialize Preline components
// Handles Turbo navigation and frame updates to ensure components are re-initialized
export default class extends Controller {
  connect() {
    // Initialize Preline components when controller connects
    HSStaticMethods.autoInit()

    // Listen for Turbo events to re-initialize components
    this.turboLoadHandler = this.reinitialize.bind(this)
    document.addEventListener("turbo:frame-load", this.turboLoadHandler)
    document.addEventListener("turbo:render", this.turboLoadHandler)
  }

  disconnect() {
    document.removeEventListener("turbo:frame-load", this.turboLoadHandler)
    document.removeEventListener("turbo:render", this.turboLoadHandler)
  }

  // Re-initialize after Turbo loads (navigation or frame updates)
  reinitialize() {
    // Small delay to ensure DOM is ready
    setTimeout(() => {
      HSStaticMethods.autoInit()
    }, 100)
  }

  // Open an overlay programmatically - use this for buttons loaded via Turbo
  // Usage: data-action="preline#openOverlay" data-preline-target-param="#modal-id"
  openOverlay({ params: { target } }) {
    if (target) {
      const overlay = document.querySelector(target)
      if (overlay) {
        // Use the imported HSOverlay, falling back to window.HSOverlay
        const HS = HSOverlay || window.HSOverlay
        if (HS) {
          HS.open(overlay)
        }
      }
    }
  }

  // Close an overlay programmatically
  closeOverlay({ params: { target } }) {
    if (target) {
      const overlay = document.querySelector(target)
      if (overlay) {
        const HS = HSOverlay || window.HSOverlay
        if (HS) {
          HS.close(overlay)
        }
      }
    }
  }

  // Toggle an overlay programmatically
  toggleOverlay({ params: { target } }) {
    if (target) {
      const overlay = document.querySelector(target)
      if (overlay) {
        const HS = HSOverlay || window.HSOverlay
        if (HS) {
          HS.toggle(overlay)
        }
      }
    }
  }
}
